import { Link, useNavigate } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";

import { RequestAccessShell } from "../../components/RequestAccessShell";
import { CHANNEL_MANAGER, RESETDATA_ADMIN } from "@/lib/role-labels";

export function RequestAccessSentStep() {
  const navigate = useNavigate();
  // CHP-809: the email is stashed by the details step on a successful submit.
  // A direct/refreshed visit (deep link, back-then-forward, or a cleared
  // session) has no email — without a guard the screen falsely confirms
  // "Request received" for a request that was never made this session. Mirror
  // details.tsx's missing-state guard: redirect back to step 1.
  const email = useMemo(
    () =>
      typeof window !== "undefined" ? sessionStorage.getItem("prm-request-access-email") : null,
    [],
  );

  useEffect(() => {
    if (!email) {
      void navigate({ to: "/request-access" });
    }
  }, [email, navigate]);

  if (!email) return null;

  return (
    <RequestAccessShell step={3} heading="Request received">
      <div className="space-y-3" data-testid="request-access-sent">
        <p className="text-sm text-muted-foreground">
          Thanks — we'll email <strong className="text-foreground">{email}</strong> when a{" "}
          {CHANNEL_MANAGER} or {RESETDATA_ADMIN} reviews your request.
        </p>
        <p className="text-sm text-muted-foreground">
          If you don't hear back within a few business days, check with the person who gave you the
          referral code.
        </p>
      </div>
      <p className="text-sm">
        <Link to="/login" className="font-medium text-primary hover:underline">
          Back to sign in
        </Link>
      </p>
    </RequestAccessShell>
  );
}
